module.exports = __webpack_public_path__ + "static/media/coupon02_en.16657a62.png";